import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

// Mock user data
const mockUser = {
  id: 'user123',
  name: 'John Doe',
  email: 'john.doe@example.com',
  joinDate: '2024-01-15',
  purchases: [
    {
      id: 'order001',
      date: '2024-12-01',
      items: [
        { id: '1', title: 'Golden Era', type: 'beat', price: 29.99 }
      ],
      total: 29.99,
      status: 'completed'
    },
    {
      id: 'order002',
      date: '2024-11-15',
      items: [
        { id: 'm1', name: 'Advocate Logo Tee - Black', type: 'merch', price: 29.99, size: 'L' },
        { id: '2', title: 'Midnight Hustle', type: 'beat', price: 34.99 }
      ],
      total: 64.98,
      status: 'completed'
    }
  ],
  billing: {
    cardLast4: '4242',
    cardBrand: 'Visa',
    expiryMonth: '12',
    expiryYear: '2026'
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is logged in (mock - always logged in for demo)
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
      setIsAuthenticated(true);
    } else {
      // Auto-login for demo
      setUser(mockUser);
      setIsAuthenticated(true);
      localStorage.setItem('user', JSON.stringify(mockUser));
    }
  }, []);

  const updateUser = (updates) => {
    const updatedUser = { ...user, ...updates };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

  const updateBilling = (billingInfo) => {
    const updatedUser = { ...user, billing: { ...user.billing, ...billingInfo } };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      isAuthenticated, 
      updateUser, 
      updateBilling,
      logout 
    }}>
      {children}
    </AuthContext.Provider>
  );
};